import React from "react";
import "../assets/css/style.css";
import "./WeddingTemplates/CSS/Medias.css";
import domtoimage from 'dom-to-image';
import $ from 'jquery';

var downloadName="invitation.jpeg";

class InvitationText extends React.Component {
  constructor(props) {
    super(props);
    console.log("in constructor sidebyside" + props.reqObject.womanName)
    this.sakura = props.isSakura;
    this.brideParents = props.reqObject.brideParents;
    this.groomParents = props.reqObject.groomParents;
    this.requestLine1 = props.reqObject.requestLine1;
    this.requestLine2 = props.reqObject.requestLine2;
    this.womanName = props.reqObject.womanName;
    this.manName = props.reqObject.manName;
    this.day = props.reqObject.day;
    this.date = props.reqObject.date;
    this.year = props.reqObject.year;
    this.time = props.reqObject.time;
    this.venue = props.reqObject.venue;
    this.venueForMaps = this.venue.split(' ').join('+');
    this.venueAddress = props.reqObject.venueAddress;
    this.cityState = props.reqObject.cityState;
    this.phone = props.reqObject.phone;
    this.footerMessage1 = props.reqObject.footerMessage1;
    this.footerMessage2 = props.reqObject.footerMessage2;
    this.endingNote = props.reqObject.endingNote;
    this.bottomLeft = props.reqObject.bottomLeft;
    this.bottomRight = props.reqObject.bottomRight;
    this.link = `https://www.google.com/maps/search/?api=1&query=${this.venueForMaps}`;
    this.myRef = React.createRef();
    this.changed = props.reqObject.changed;
    this.baseSong = props.reqObject.baseSong;
    this.isSideBySide = props.reqObject.isSideBySide;
    this.reqObject=props.reqObject;
    console.log(props.reqObject.template)
    this.template = props.reqObject.template;


  }

   isupdate = 0;
  componentWillUpdate() {
    
    console.log("in sakura sidebyside" + this.reqObject.isSideBySide)
    console.log("in sakura sidebyside" + this.props.reqObject.template)
    if (this.reqObject.isSideBySide) {
     
      this.brideParents = this.props.reqObject.brideParents;
      this.groomParents = this.props.reqObject.groomParents;
      this.requestLine1 = this.props.reqObject.requestLine1;
      this.requestLine2 = this.props.reqObject.requestLine2;
      this.womanName = this.props.reqObject.womanName.capitalize();
      this.manName = this.props.reqObject.manName.capitalize();
      this.day = this.props.reqObject.day;
      this.date = this.props.reqObject.date;
      this.year = this.props.reqObject.year;
      this.time = this.props.reqObject.time;
      this.venue = this.props.reqObject.venue;
      this.venueForMaps = this.venue.split(' ').join('+');
      this.venueAddress = this.props.reqObject.venueAddress;
      this.cityState = this.props.reqObject.cityState;
      this.phone = this.props.reqObject.phone;
      this.footerMessage1 = this.props.reqObject.footerMessage1;
      this.footerMessage2 = this.props.reqObject.footerMessage2;
      this.endingNote = this.props.reqObject.endingNote;
      this.bottomLeft = this.props.reqObject.bottomLeft;
      this.bottomRight = this.props.reqObject.bottomRight;
      this.link = `https://www.google.com/maps/search/?api=1&query=${this.venueForMaps}`;
      this.myRef = React.createRef();
      this.changed = this.props.reqObject.changed;
      this.isSideBySide = this.props.reqObject.isSideBySide;
      this.reqObject =
    {
      isSideBySide:true,
      loadingActive:false,
      customDesign:'',
      template: this.template,
      brideParents: this.props.reqObject.brideParents,
      groomParents: this.props.reqObject.groomParents,
      requestLine1: this.props.reqObject.requestLine1,
      requestLine2: this.props.reqObject.requestLine2,
      womanName: this.props.reqObject.womanName,
      manName: this.props.reqObject.manName,
      day: this.props.reqObject.day,
      date: this.props.reqObject.date,
      year: this.props.reqObject.year,
      time: this.props.reqObject.time,
      brideInitial : this.props.reqObject.womanName.charAt(0).capitalize(),
      groomInitial :  this.props.reqObject.manName.charAt(0).capitalize(),
      venue: this.props.reqObject.venue,
      venueForMaps: this.props.reqObject.venueForMaps,
      venueAddress: this.props.reqObject.venueAddress,
      cityState: this.props.reqObject.cityState,
      phone: this.props.reqObject.phone,
      link: this.props.reqObject.link,
      footerMessage1: this.props.reqObject.footerMessage1,
      footerMessage2: this.props.reqObject.footerMessage2,
      endingNote: this.props.reqObject.endingNote,
      bottomLeft: this.props.reqObject.bottomLeft,
      bottomRight: this.props.reqObject.bottomRight,
      changed: this.props.reqObject.changed
    }
      if (this.isupdate === 0) {
        this.isupdate++;
      
        this.setState((prevState, props) => ({
          changed: !this.props.reqObject.changed
        }));
        console.log('supppp' + this.changed)
      }
      else {
        this.isupdate = 0;
      }
    }
  }
 
  
  RSVP() {
    if (this.reqObject.isSideBySide) {
      window.alert("RSVP will be available once payment has been made.")
    }
    if(this.reqObject.allowRsvp!=='true')
    {
      window.alert("RSVP is not available for this invitation.")
    }
    else {
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get('documentId');
      window.location.href = "/RSVP?documentId=" + myParam;
    }
  }
  DownloadPdf() {
    if(this.reqObject.isSideBySide)
    {
      window.alert("Downloading Document will be available once payment has been made.")
    }
    else
    {
    window.scrollTo(0, 0)
    
    document.getElementById("download-button").style.display = "none";
    document.getElementById("directions-button").style.display = "none";
    document.getElementById("RSVPButton").style.display = "none";
    var node = document.getElementById('fullInvite');
    
    downloadName= this.reqObject.womanName + '_and_' + this.reqObject.manName + `'s_Wedding.jpeg`;

    domtoimage.toJpeg(node,{ quality: 1 })
      .then(function (dataUrl) {
        var link = document.createElement('a');
        link.download = downloadName;
        link.href = dataUrl;
        link.click();
      }).then(function() {
        document.getElementById("download-button").style.display = "block";
        document.getElementById("directions-button").style.display = "block";
        document.getElementById("RSVPButton").style.display = "block";
      })
      .catch(function (error) {
          console.error('oops, something went wrong!', error);
      }).then(function() {
        document.getElementById("download-button").style.display = "block";
        document.getElementById("directions-button").style.display = "block";
        document.getElementById("RSVPButton").style.display = "block";
      });
    }
  }

  componentDidMount()
  {
    if(window.screen.width > 600)
    {
      this.zoomSquare() 
      window.addEventListener('resize', this.zoomSquare)
    }

    if(this.reqObject.allowRsvp==='true')
    {
      document.getElementById('RSVPButton').style.display = 'block'
    }
  }
  
   zoomSquare() {
    
    var $square = $('#fullCard');

    var viewportHeight = $(window).height();
    var squareHeight = $square.height();
    var desiredHeight = Math.round(viewportHeight * 0.95);
    var zoom = (desiredHeight / squareHeight);

    $square.css('zoom', zoom);
    $square.css('-moz-transform', 'scale(' + zoom + ')');
    $square.css(  '-o-transform', 'scale(' + zoom + ')');
}

  render() {
    var buttonsCss = "venue-wedding " + this.template+"-venue-wedding"
    var buttonDownload = buttonsCss + " downloadButton-wedding"
    var womanNameCss = this.template+"-woman-name-wedding";
    var andSignCss = this.template+"-and-sign-wedding";
    var manNameCss = this.template+"-man-name-wedding";
    var headerStyle = this.template+"-header-style-wedding";
    var titleCss = this.template+"-title-wedding title-wedding";
    var invitationFooter = this.template+"-invitation-footer-wedding invitation-footer-wedding";
    var timeVenue = this.template+"-dance-sm-wedding dance-sm-wedding";
    var happiness = this.template+"-happiness-wedding happiness-wedding";
    var bottomRightText = this.template+"-bottom-right-text-wedding "+ this.template+"-bottom-right-wedding bottom-text-wedding";
    var bottomLeftText = this.template+"-bottom-left-text-wedding "+ this.template+"-bottom-left-wedding bottom-text-wedding";

    const userFont = this.props.reqObject.fontFamily;
    const userScale = this.props.reqObject.fontSize;
    const fontOverride = (userFont && userFont !== "default")
      ? `#defaulText, #defaulText *, #fullCard *, #fullInvite * { font-family: ${userFont} !important; }`
      : "";
    const scale = (userScale && userScale !== "default") ? parseFloat(userScale) : null;
    const scaleOverride = (scale && !Number.isNaN(scale))
      ? `#defaulText { font-size: ${scale}em !important; }
         #defaulText h1, #fullCard h1, #fullInvite h1 { font-size: ${3 * scale}rem !important; }
         #defaulText h2, #fullCard h2, #fullInvite h2 { font-size: ${2 * scale}rem !important; }
         #defaulText p, #fullCard p, #fullInvite p { font-size: ${1 * scale}rem !important; }`
      : "";

    return (
        <div id = "defaulText" >
         {(fontOverride || scaleOverride) && <style>{fontOverride + scaleOverride}</style>}
         <section id="media" />
          <div className="wrap">
            <div className={titleCss}>
            <div style={{textAlign: "right", color: "black", marginBottom: "30px"}}>
              <p style={{color: "black"}}>בס״ד</p>
            </div>
              <p className = {headerStyle}>With Gratitude to Hashem</p>
              <p className = {headerStyle}>{this.brideParents}</p>
              <p className = {headerStyle}>{this.groomParents}</p>
              <p className = {headerStyle}>{this.requestLine1}</p>
              <p className = {headerStyle}>{this.requestLine2}</p>
              <h1 className = {womanNameCss}>{this.womanName}</h1>
              <h2 className ={andSignCss}>&amp;</h2>
              <h1 className ={manNameCss}>{this.manName}</h1>
            </div>
          </div>
          <p className={timeVenue}>{this.day}, {this.date}</p>
          <p className={timeVenue}>{this.year}</p>
          <p className={timeVenue}>At {this.time}</p>
          <p className={timeVenue}>{this.venue}</p>
          <p className={timeVenue}>{this.venueAddress}</p>
          <p className={timeVenue}>{this.cityState}</p>
          {/* <div className="actions">
            <a id = "RSVPButton" style={{display:"none", zIndex:"5"}} href={() => false} onClick={() => this.RSVP()}>
              <div classN ame ={buttonsCss}><b>RSVP</b></div>
            </a>
            <a href={this.link} target="_blank" rel="noopener noreferrer" id="directions-button">
              <div className={buttonsCss} ><b>DIRECTIONS</b></div>
            </a>
            <a href={() => false} onClick={() => this.DownloadPdf()} id="download-button">
              <div className={buttonDownload}><b>DOWNLOAD</b></div>
            </a>
          </div> */}
          <p className={invitationFooter}>
            {this.footerMessage1} <br />{this.footerMessage2}
            <span />
          </p>
          <div>
            {this.props.reqObject.isSideBySide ?
              null :
              <audio className="audio-element" src={this.baseSong}>
              </audio>

            }
          </div>
          <p className={happiness}>{this.endingNote}<br /></p>
          <p className={bottomRightText} style={{marginBottom:0}}>{this.bottomRight}</p>
          <p className={bottomLeftText}>{this.bottomLeft}</p>
        </div>
    );
  }
}

export default InvitationText;